














































import { Vue, Component } from "vue-property-decorator";
import { User } from "@/components/User";

@Component
export default class UserLogin extends Vue {
  private username: string = '';
  private password: string = '';
  private errorMessage: string = null;

  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  };

  set SelectedApp(app:string) {
    this.$store.commit('notifyChange', {
      SelectedApp: app
    });
  };

  async login() {
    try {
      let user = new User();
      await user.login(this.username, this.password);
      this.$store.commit('notifyChange', {
        User: user, // .Properties,
        SelectedApp: (user.isSuperAdmins || user.isAdmins) ? 'admin' : 'userprofile'
      });
    } catch (error) {
      if (error.id="unauthorized") {
        //this.errorMessage = 'Login is not successful. Please enter correct user name and password'
        this.errorMessage = 'ล็อกอินไม่สำเร็จ กรุณาตรวจสอบว่ารหัสผู้ใช้และรหัสผ่านถูกต้องหรือไม่';
      }
    }
  }
}
